import { CtaType } from "../../../types/Cta";
import { put } from "../../../utils/axios-config";
import { CTAS } from "../../../utils/constants";

export const updateCta = async (data: CtaType) => await put<CtaType, string>(CTAS, data);